<script>
import { mapState } from 'vuex';
import Loading from '../../components/loading.vue';

export default {
    name: "artistDetail",
    data() {
        return {
            swiperOptions: {
                observer: true,
                observeParents: true,
                simulateTouch: false,
                loop: false,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev',
                },
                slidesPerView: 'auto',
                spaceBetween: '3.5715%',
            },
            detail: {
                works: [],
                exhibition: [],
                awards: [],
                publication: [],
            },
            isLoading: false,
        };
    },
    computed: {
        ...mapState(['galleryHome'])
    },
    components: {
        Loading
    },
    mounted() {
        this.getData();
    },
    destroyed() {},
    watch: {},
    methods: {
        getData() {
            this.isLoading = true;
            this.$store.dispatch('getGalleryArtistDetail', {
                id: this.$route.query.id
            }).then((result) => {
                this.isLoading = false;
                if (result.code == 100) { 
                    this.detail = result.data;
                }
            }).catch((err) => {
                this.isLoading = false;
            });
        }
    },
};
</script>

<template>
    <div class="artist_detail">
        <div class="layout_body">
            <!-- banner -->
            <div class="banner only_pc">
                <div class="layout_bg" :style="`background-image: url(${galleryHome.artist_banner});`"></div>
            </div>
            <div class="layout_main">
                <div class="layout_content" v-if="isLoading">
                    <Loading/>
                </div>
                <div class="layout_content" v-else>
                    <p class="breadcrumb only_pc"><router-link to="/gallery">A+ Studio Gallery</router-link> / <router-link to="/gallery/artist">艺术家</router-link> / {{ detail.name }}</p>
                    <div class="all_name flex align_center only_pc">
                        <p>{{ detail.name }}</p>
                        <p>{{ detail.en_name }}</p>
                    </div>
                    <div class="tabs flex only_pc">
                        <div class="item">简历</div>
                        <div class="item">作品</div>
                    </div>
                    <div class="detail flex">
                        <div class="cover">
                            <div class="layout_bg bg" :style="`background-image: url(${detail.image});`"></div>
                        </div>
                        <div class="text">
                            <div class="flex justify_between only_pc">
                                <p class="name">{{ detail.name }}</p>
                                <div class="btn">关注我</div>
                            </div>
                            <p class="name only_mobile">{{ detail.name }}</p>
                            <p class="desc" v-html="$textToHtml(detail.desc)"></p>
                        </div>
                    </div>
                    <div class="only_mobile">
                        <div class="flex justify_between align_center">
                            <div class="tabs flex">
                                <div class="item">简历</div>
                                <div class="item">作品</div>
                            </div>
                            <div class="btn_follow">关注我</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-if="detail.works.length > 0">
            <div class="layout_main">
                <swiper class="swiper only_pc" :options="swiperOptions">
                    <swiper-slide v-for="(item, index) in detail.works" :key="index">
                        <router-link :to="`/gallery/works/detail?id=${item.id}`">
                            <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                            <!-- <p class="text">Inari</p> -->
                            <p class="name">{{ item.name }}</p>
                            <p class="price" v-if="item.price == '0.00'">免费</p>
                            <p class="price" v-else>RMB {{ item.price }}</p>
                        </router-link>
                    </swiper-slide>
                    <div class="swiper-button-prev" slot="button-prev"></div>
                    <div class="swiper-button-next" slot="button-next"></div>
                </swiper>
                <div class="only_mobile">
                    <div class="works flex flex_wrap">
                        <router-link class="item" v-for="(item, index) in detail.works" :key="index" :to="`/gallery/works/detail?id=${item.id}`">
                            <div class="layout_bg cover" :style="`background-image: url(${item.image});`"></div>
                            <!-- <p class="text">Inari</p> -->
                            <p class="name">{{ item.name }}</p>
                            <p class="price" v-if="item.price == '0.00'">免费</p>
                            <p class="price" v-else>RMB {{ item.price }}</p>
                        </router-link>
                    </div>
                </div>
                <div class="flex justify_end">
                    <p class="link"><router-link :to="`/gallery/works?artist=${detail.id}`">全部作品</router-link></p>
                </div>
            </div>
        </div>
        <div class="content" v-if="detail.exhibition.length > 0">
            <div class="layout_main">
                <div class="title">展览</div>
                <table class="table">
                    <tr class="tr" v-for="(item, index) in detail.exhibition" :key="index">
                        <td class="td time">{{ item.year }}</td>
                        <td class="td name">{{ item.name }}</td>
                        <td class="td address">{{ item.gallery }}</td>
                        <td class="td region">{{ item.city }}</td>
                        <td class="td country">{{ item.country }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="content" v-if="detail.awards.length > 0">
            <div class="layout_main">
                <div class="title">奖项</div>
                <table class="table">
                    <tr class="tr" v-for="(item, index) in detail.awards" :key="index">
                        <td class="td time">{{ item.year }}</td>
                        <td class="td name">{{ item.name }}</td>
                    </tr>
                </table>
            </div>
        </div>
        <div class="content" v-if="detail.publication.length > 0">
            <div class="layout_main">
                <div class="title">出版物/新闻</div>
                <table class="table">
                    <tr class="tr" v-for="(item, index) in detail.publication" :key="index">
                        <td class="td time">{{ item.year }}</td>
                        <td class="td name">{{ item.name }}</td>
                    </tr>
                </table>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.banner{
    height: 4.8rem;
}
.layout_content{
    @media only screen and (max-width: 750px) {
        padding: 0;
    }
}
.breadcrumb{
    font-size: .2rem;
    color: #666;
    margin-bottom: .3rem;
}
.all_name{
    font-size: .3rem;
    gap: .3rem;
    line-height: 1;
    margin-bottom: .3rem;
}
.tabs{
    gap: .3rem;
    font-size: .18rem;
    color: #666;
    margin-bottom: .3rem;
    .item{
        border-bottom: 1px solid #666;
    }
    @media only screen and (max-width: 750px) {
        font-size: .26rem;
    }
}
.btn_follow{
    @media only screen and (max-width: 750px) {
        font-size: .26rem;
        border-bottom: 1px solid #666;
    }
}
.detail{
    gap: .4rem;
    .cover{
        width: 2.9rem;
        .bg{
            height: 0;
            padding-bottom: 129.65%;
        }
    }
    .text{
        flex: 1;
        .name{
            font-size: .25rem;
            margin-bottom: .1rem;
        }
        .desc{
            line-height: 1.8;
            font-size: .2rem;
        }
        .btn{
            height: .36rem;
            padding: 0 .2rem;
            font-size: .2rem;
            border: 1px solid #333;
            border-radius: .1rem;
            cursor: pointer;
        }
    }
    @media only screen and (max-width: 750px) {
        flex-direction: column;
        margin-bottom: .5rem;
        .cover{
            width: 7.5rem;
            height: 8.2rem;
            margin: 0 -.3rem;
            .bg{
                height: 100%;
                padding-bottom: 0;
            }
        }
        .text{
            .name{
                text-align: center;
                font-size: .32rem;
            }
            .desc{
                font-size: .28rem;
                text-align: justify;
            }
        }
    }
}
.content{
    padding: .5rem 0;
    border-bottom: 1px solid #999;
    &:last-child{
        border-bottom: none;
    }
    @media only screen and (max-width: 750px) {
        border-bottom: none;
        border-top: 1px solid #999;
    }
    .link{
        margin-top: .3rem;
        font-size: .2rem;
        color: #666;
        border-bottom: 1px solid #666;
    }
    .title{
        font-size: .25rem;
        font-weight: bold;
        margin-left: .4rem;
        margin-bottom: .4rem;
        @media only screen and (max-width: 750px) {
            text-align: center;
            font-size: .28rem;
            margin-left: 0;
        }
    }
}
.works{
    gap: .3rem;
    .item{
        width: 3.3rem;
        font-size: .26rem;
        text-align: center;
        line-height: 1.8;
        .cover{
            height: 0;
            padding-bottom: 100%;
            // border: 1px solid #666;
            margin-bottom: .2rem;
        }
    }
}
.swiper{
    padding: 0 .4rem;
    text-align: center;
    font-size: .2rem;
    line-height: 1.6;
    .swiper-slide{
        width: 2.5rem;
    }
    .cover{
        height: 0;
        padding-bottom: 100%;
        // border: 1px solid #666;
        margin-bottom: .2rem;
    }
    --swiper-navigation-color: #999;/* 单独设置按钮颜色 */
    --swiper-navigation-size: .25rem;/* 设置按钮大小 */
    .swiper-button-prev,
    .swiper-button-next{
        top: 1.25rem;
        margin-top: 0;
        transform: translate(0, -50%);
        padding: .2rem;
        &.swiper-button-disabled{
            opacity: 0;
        }
    }
    .swiper-button-prev{
        left: 0;
    }
    .swiper-button-next{
        right: 0;
    }
}
.table{
    margin: 0 .4rem;
    font-size: .2rem;
    line-height: 2;
    @media only screen and (max-width: 750px) {
        font-size: .24rem;
        margin: 0;
    }
    .tr{
        td{
            padding-right: .4rem;
            box-sizing: border-box;
            @media only screen and (max-width: 750px) {
                padding-right: .3rem;
            }
        }
        .time{
            min-width: 1.4rem;
            @media only screen and (max-width: 750px) {
                min-width: 1rem;
            }
        }
        .name{
            min-width: 2.4rem;
            @media only screen and (max-width: 750px) {
                min-width: 1.4rem;
            }
        }
        .address,
        .region,
        .country{
            min-width: 1.8rem;
            @media only screen and (max-width: 750px) {
                min-width: 1.4rem;
            }
        }
    }
}
</style>